import React, { useState } from "react";
import { Container, Nav } from "react-bootstrap";
import { useFetchAnneeScolairesQuery } from "features/anneeScolaire/anneeScolaireSlice";
import { useFetchBackupsQuery } from "features/backups/backupsSlice";
import DashboardTab from "./DashboardTab";
import WizardTab from "./WizardTab";
import ArchivesTab from "./ArchivesTab";
import BackupsTab from "./BackupsTab";
import HistoryTab from "./HistoryTab";

type TabKey = "dashboard" | "wizard" | "archives" | "backups" | "history";

const TABS: { key: TabKey; label: string; icon: string }[] = [
  { key: "dashboard", label: "Tableau de bord", icon: "ri-dashboard-line" },
  { key: "wizard", label: "Fin d'année", icon: "ri-skip-forward-line" },
  { key: "archives", label: "Archives", icon: "ri-archive-line" },
  { key: "backups", label: "Sauvegardes", icon: "ri-hard-drive-2-line" },
  { key: "history", label: "Historique", icon: "ri-time-line" },
];

const AnneeScolaire = () => {
  const { data: annees = [] } = useFetchAnneeScolairesQuery();
  const { data: backups = [] } = useFetchBackupsQuery();

  const [activeTab, setActiveTab] = useState<TabKey>("dashboard");
  const [archivesInitialAnnee, setArchivesInitialAnnee] = useState("");

  const currentAnnee = annees.find((a) => a.isCurrent);

  const goToArchives = (anneeLabel?: string) => {
    if (anneeLabel) setArchivesInitialAnnee(anneeLabel);
    setActiveTab("archives");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Page header */}
          <div className="d-flex align-items-center mb-3">
            <h4 className="mb-0 flex-grow-1">
              <i className="ph ph-graduation-cap me-2"></i>
              Cycle scolaire
            </h4>
            {currentAnnee && (
              <span className="text-muted">
                Année en cours : <strong className="text-primary">{currentAnnee.label}</strong>
              </span>
            )}
          </div>

          {/* Tab navigation */}
          <Nav variant="tabs" className="nav-tabs-custom mb-4">
            {TABS.map((tab) => (
              <Nav.Item key={tab.key}>
                <Nav.Link
                  active={activeTab === tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className="d-flex align-items-center gap-1"
                  style={{ cursor: "pointer" }}
                >
                  <i className={tab.icon}></i>
                  <span className="d-none d-md-inline">{tab.label}</span>
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>

          {/* Tab content */}
          {activeTab === "dashboard" && (
            <DashboardTab
              currentAnnee={currentAnnee}
              annees={annees}
              backups={backups}
              migrationDone={true}
              onGoToWizard={() => setActiveTab("wizard")}
              onGoToBackups={() => setActiveTab("backups")}
              onGoToArchives={() => goToArchives()}
            />
          )}
          {activeTab === "wizard" && <WizardTab currentAnnee={currentAnnee} />}
          {activeTab === "archives" && <ArchivesTab initialAnnee={archivesInitialAnnee} />}
          {activeTab === "backups" && <BackupsTab />}
          {activeTab === "history" && <HistoryTab onGoToArchives={goToArchives} />}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AnneeScolaire;
